<template>
  <div class="home-page txtcenter" style="height:100vh;" v-if="gameUrl">
    <iframe class="iframe" :src="gameUrl"></iframe>
	</div>
</template>
<script>
export default {
    components:{
    },
    data() {

    return {
			gameUrl:'',
			msg:'',

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
      Utils.$ajax({
          url: '/game/go&game_id='+this.$route.query.game_id
      }).done(res=>{
        console.log(res)
          if(res.code != 0){
              this.$messagebox_lang(res.msg).then();
              return;
          }else{
            this.gameUrl = res.data.url
          }
      })
		},
	}
}
</script>
<style lang="scss" scoped>
  .home-page{margin-top: rem(-182);}
  .iframe{width:100%;height:100%;border:none;}
</style>



// WEBPACK FOOTER //
// src/components/game.vue